<template>
  <div>
    <a-modal v-model:visible="visible" title="新增药名" @ok="handleOk" okText="确认" cancelText="关闭" :afterClose="closeModal" width="35vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <a-form-item label="一键复制的周数">
          <a-input v-model:value="data.count" @change="changeDate" />
        </a-form-item>
        <a-form-item label="需排班的开始周次">
          <a-select v-model:value="data.destDateFrom" @change="changeDate">
            <a-select-option v-for="item in dateOption" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="data.count>1" label="需排班的结束周次">
          <a-input v-model:value="data.endDate" readOnly />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import medicineSelector from '/src/components/selector/medicineSelector.vue';
import { CopySchedule } from "/src/api/appointment.js";
export default {
  components: {
    medicineSelector
  },
  data() {
    return {
      visible: this.modelValue,
      medicineFilter: "",
      medicine: "",
      data: {
        count: 1,
        destDateFrom: "",
        destDateTo: "",
      },
      dateOption: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
    this.init()
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: "",
    },
    record: {
      type: Array,
      default: () => [],
    },
    clubId: {
      type: Number,
      default: null,
    }
  },
  computed: {

  },
  methods: {
    init() {
      this.getWeekOptions()
    },
    filterNameInitial(input) {
      this.medicineFilter = input?.toLowerCase();
    },
    filter() {
      return true
    },
    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      } else {
        this.$message.error("删除失败", function () { });
      }

    },
    getWeekOptions(weekCount = 10) {
      console.log(this.date);

      const options = [];
      const startDay = this.date ? new Date(this.date) : new Date();

      // 获取下周一
      const day = startDay.getDay();
      const daysUntilNextMonday = day === 0 ? 1 : 8 - day;
      const nextMonday = new Date(startDay);
      nextMonday.setDate(startDay.getDate() + daysUntilNextMonday);

      for (let i = 0; i < weekCount; i++) {
        const weekStart = new Date(nextMonday);
        weekStart.setDate(nextMonday.getDate() + (i * 7));

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        const year = weekStart.getFullYear();
        const weekNumber = this.getWeekNumber(weekStart);
        const dateStr = this.formatDate(weekStart);

        const startDateStr = this.formatDate(weekStart);
        const endDateStr = this.formatDate(weekEnd);

        options.push({
          label: `${year}年第${weekNumber}周（${startDateStr} - ${endDateStr}）`,
          value: dateStr
        });
      }

      this.dateOption = options;
    },

    // 获取周数
    getWeekNumber(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
      return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    },

    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 格式化中文日期（XXXX年XX月XX日）
    formatChineseDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}年${month}月${day}日`;
    },

    // 获取周数
    getWeekNumber(date) {
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
      return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    },

    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async handleOk() {
      console.log(this.record);

      let _this = this;
      let parmas = {
        doctorIds: this.record,
        clubId: this.clubId,
        srcDateFrom: this.formatDate(this.date),
        ...this.data
      }
      console.log(parmas);

      let res = await CopySchedule(parmas)
      if (res.errCode == 0) {
        _this.$message.success("复制成功", function () { });
        _this.visible = false
        this.data = {
          count: 1,
          destDateFrom: "",
          destDateTo: "",
        }
      }
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },

    changeNameInitial() {
      this.data.nameInitial = this.getInitial(this.data.name)
    },
    changeDate() {
      // 如果开始周次或周数未设置，则不计算
      if (!this.data.destDateFrom || !this.data.count) {
        this.data.destDateTo = "";
        return;
      }

      try {
        // 解析开始日期（周一的日期）
        const startDate = new Date(this.data.destDateFrom);

        // 计算结束周次的周一日期
        const endMonday = new Date(startDate);
        endMonday.setDate(startDate.getDate() + (this.data.count - 1) * 7);

        // 计算该周的周日日期（周一 + 6天）
        const endSunday = new Date(endMonday);
        endSunday.setDate(endMonday.getDate() + 6);

        // 格式化结束日期（显示周日的日期）
        this.data.destDateTo = this.formatDate(endSunday);


        const year = endMonday.getFullYear();
        const weekNumber = this.getWeekNumber(endMonday);
        const startDateStr = this.formatDate(endMonday);
        const endDateStr = this.formatDate(endSunday);


        this.data.endDate = `${year}年第${weekNumber}周（${startDateStr} - ${endDateStr}）`

      } catch (error) {
        console.error("日期计算错误:", error);
        this.data.destDateTo = "";
      }
    }
    //初始化data所有数据，并关闭modal
  },
  watch: {
    modelValue(val) {
      this.visible = val
    },

  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
